module.exports = __webpack_public_path__ + "static/media/report_18.a5e4fc95.jpg";